import React, { useEffect, useState } from 'react';
import { Oval } from 'react-loader-spinner';
import api from '../services/api';
import LazyImage from '../components/LazyImage';
import { Page, Header, Section, Grid, Card } from './ObjectivesStyles';

const Objectives = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.objectives.get().then(setData).catch(err => setError(err.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Oval height={48} width={48} color="#2E8B57" secondaryColor="#CDEAD7" />
    </div>
  );
  if (error) return <div style={{ padding: 20 }}>Error: {error}</div>;
  if (!data) return null;

  const { intro, objectives, sections } = data;

  return (
    <Page>
      <Header>
        <h1>Objectives</h1>
        <p>{intro || '—'}</p>
      </Header>

      <Section>
        <h2 style={{ color: '#1B5E20', margin: '0 0 12px' }}>Key Objectives</h2>
        <Grid>
          {(objectives || []).map((o, idx) => (
            <Card key={idx}>
              {o.image ? <LazyImage src={o.image} alt={o.title || 'Objective'} /> : null}
              <h3>{o.title || 'Objective'}</h3>
              <p>{o.description || '—'}</p>
            </Card>
          ))}
        </Grid>
      </Section>

      <Section>
        <h2 style={{ color: '#1B5E20', margin: '0 0 12px' }}>Sections</h2>
        <Grid>
          {(sections || []).map((s, idx) => (
            <Card key={idx}>
              {s.image ? <LazyImage src={s.image} alt={s.title || 'Section'} /> : null}
              <h3>{s.title || 'Section'}</h3>
              {s.type === 'list'
                ? (
                  <ul>
                    {(s.content || '').split('\n').map(line => line.trim()).filter(Boolean).map((line, liIdx) => (
                      <li key={liIdx}>{line}</li>
                    ))}
                  </ul>
                ) : (
                  <p>{s.content || '—'}</p>
                )}
            </Card>
          ))}
        </Grid>
      </Section>
    </Page>
  );
};

export default Objectives;
